import { defineMessages } from 'react-intl';

const messages = defineMessages({
  GiftCard: {
    description: 'Payment type when a return is processed to a gift card',
    defaultMessage: 'Gift Card',
    id: 'bq2+p+',
  },
  OriginalPaymentMethod: {
    description: 'Payment type when a return is processed to the original payment method',
    defaultMessage: 'Original Payment Method',
    id: 'wJnHr2',
  },
});

export const ReturnPaymentTypes = Object.freeze({
  GiftCard: Object.freeze({
    translation: messages.GiftCard,
    key: 'GIFT_CARD',
  }),
  OriginalPaymentMethod: Object.freeze({
    translation: messages.OriginalPaymentMethod,
    key: 'ORIGINAL_PAYMENT_METHOD',
  }),
});
